<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>盲盒配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importUploadSuccess(res)}" :headers="headers">
                <el-button :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <!-- Level Range Sections -->
        <div v-for="(rangeItem, index) in formData" :key="index" class="level-range-section">
          <el-row :gutter="20" style="margin-bottom: 20px; align-items: center;">
            <el-col :span="1.5">
              <div style="line-height: 32px; text-align: right; padding-right: 10px;">等级区间</div>
            </el-col>
            <el-col :span="2">
              <el-input
                v-model="rangeItem.condition"
                placeholder="例如: 0-10"
                size="small"
                style="width: 120px;"
              />
            </el-col>
            <el-col :span="1.5">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-plus"
                @click="addRewardWeight(index)"
              >
                添加奖励权重
              </el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                :disabled="formData.length === 1"
                @click="delLevelRange(index)"
              >
                删除区间
              </el-button>
            </el-col>
          </el-row>

          <!-- Reward Weights Table -->
          <el-table
            style="border:1px solid #ccc; margin-bottom: 20px;"
            :data="rangeItem.rewardConfig"
            border
            stripe
            size="small"
          >
            <el-table-column label="权重">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.weight" size="mini" style="width: 80px;" />
              </template>
            </el-table-column>
            <el-table-column label="奖励">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot:default="scope">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delRewardWeight(index, scope.$index)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-button style="margin-top: 10px" type="primary" @click="addLevelRange()">+ 添加等级区间</el-button>
        <el-button style="margin-top: 10px; margin-left: 10px;" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getBlindBoxList, updateBlindBox, exportBlindBox, importBlindBox } from '@/api/config/tetris/blind-box'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import Reward from '@/components/Reward'
export default {
  name: 'TetrisBlindBox',
  components: { SyncData, ClearCacheApply, Reward },
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      formData: [
        {
          'condition': '0-10',
          'rewardConfig': [
            {
              'weight': 0,
              'reward': []
            }
          ]
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      // Validate level ranges
      // 解析所有区间并检查重叠
      const ranges = []
      for (const rangeItem of this.formData) {
        if (!rangeItem.condition || !/^\d+-\d+$/.test(rangeItem.condition)) {
          this.msgError('等级区间格式不正确，例如: 0-10')
          return
        }

        // 解析区间的最小值和最大值
        const [min, max] = rangeItem.condition.split('-').map(Number)
        if (isNaN(min) || isNaN(max) || min < 0 || max < min) {
          this.msgError('等级区间必须是有效的数字范围，且第一个值必须小于等于第二个值，例如: 0-10 或 1-1')
          return
        }

        // 检查与已存在的区间是否重叠
        for (const existing of ranges) {
          // 区间重叠的条件：当前区间的最小值小于等于已有区间的最大值，且当前区间的最大值大于等于已有区间的最小值
          // 对于单值区间（min == max），检查是否与已有区间的任何值重叠
          if (min === max) {
            if (min >= existing.min && min <= existing.max) {
              this.msgError('等级区间 ' + rangeItem.condition + ' 与 ' + existing.condition + ' 重叠了')
              return
            }
          } else {
            if (min <= existing.max && max >= existing.min) {
              this.msgError('等级区间 ' + rangeItem.condition + ' 与 ' + existing.condition + ' 重叠了')
              return
            }
          }
        }

        ranges.push({
          condition: rangeItem.condition,
          min: min,
          max: max
        })

        // Validate reward weights
        if (!rangeItem.rewardConfig || rangeItem.rewardConfig.length === 0) {
          this.msgError('等级区间 ' + rangeItem.condition + ' 至少需要一个奖励权重')
          return
        }

        for (const weightItem of rangeItem.rewardConfig) {
          if (!weightItem.weight || weightItem.weight <= 0) {
            this.msgError('奖励权重必须大于0')
            return
          }
          if (!weightItem.reward || weightItem.reward.length === 0) {
            this.msgError('奖励不能为空')
            return
          }
        }
      }

      // Transform data to required format
      const submitData = this.formData.map(rangeItem => {
        return {
          condition: rangeItem.condition,
          rewardConfig: rangeItem.rewardConfig.map(weightItem => {
            return {
              weight: weightItem.weight,
              reward: weightItem.reward.map(r => ({
                propsId: r.propsId,
                num: r.num,
                skin: r.skin || 0,
                rtype: r.rtype || 0
              }))
            }
          })
        }
      })

      const data = JSON.stringify(submitData)
      updateBlindBox({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getBlindBoxList().then(res => {
        const list = res.data || []
        this.formData = list.map(item => {
          return {
            condition: item.condition,
            rewardConfig: item.rewardConfig.map(weightItem => {
              return {
                weight: weightItem.weight,
                reward: weightItem.reward.map(r => ({
                  propsId: r.propsId || r.item_id,
                  num: r.num,
                  skin: r.skin || 0,
                  rtype: r.rtype || 0
                }))
              }
            })
          }
        })
      })
    },
    addLevelRange() {
      this.formData.push({
        'condition': '',
        'rewardConfig': [
          {
            'weight': 0,
            'reward': []
          }
        ]
      })
    },
    delLevelRange(index) {
      this.$confirm('此操作将在本地删除该等级区间数据, 点击保存后生效。是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.splice(index, 1)
        this.msgSuccess('已在本地删除，点击保存后生效')
      })
    },
    addRewardWeight(rangeIndex) {
      this.formData[rangeIndex].rewardConfig.push({
        'weight': 10,
        'reward': []
      })
    },
    delRewardWeight(rangeIndex, weightIndex) {
      this.$confirm('此操作将在本地删除该奖励权重数据, 点击保存后生效。是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData[rangeIndex].rewardConfig.splice(weightIndex, 1)
        this.msgSuccess('已在本地删除，点击保存后生效')
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importBlindBox({ data: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportBlindBox().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.level-range-section {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
  background-color: #fafafa;
}

.level-range-section:last-child {
  margin-bottom: 0;
}
</style>
